import { INTEGRATOR_MODULE_DEFINITIONS } from "@hub-modules";

/**
 * Chip label for the current module. Personal is omitted from the dropdown but still
 * shown here so the last operational module (MRP, and similar) is not implied.
 */
export function resolveAppSwitcherChipApp<T extends { key: string }>(
  activeKey: string,
  visibleApps: readonly T[],
): (typeof INTEGRATOR_MODULE_DEFINITIONS)[number] | T | undefined {
  return INTEGRATOR_MODULE_DEFINITIONS.find((app) => app.key === activeKey) ?? visibleApps[0];
}
